import * as React from 'react';
import { IShowcase } from '../../types/showcase/props';
import { ShowcaseCatContainer } from '../ShowcaseCatContainer/ShowcaseCatContainer';

export const ShowCaseContainer: React.FC<IShowcase> = props => {
  return <ShowcaseCatContainer {...props} />;
};
